<template>
  <label :class="{ 'has-error': hasError }">
    <slot name="label"></slot>

    <input
      v-model="input"
      v-bind="attrs"
      v-on="listeners"
      :class="classes">

    <div class="error">
      {{ messageError }}
    </div>
  </label>
</template>

<script>
import service from '../../api/index'
import { mapActions } from 'vuex'

export default {
  name: 'VUploadField',
  inheritAttrs: false,
  props: {
    block: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    messageError: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      required: true
    }
  },
  data: () => ({
    input: ''
  }),
  mounted () {
    this.input = this.value
  },
  computed: {
    classes () {
      let classes = 'text-field'
      if (this.block) {
        classes += ' text-field--block'
      }
      return classes
    },
    listeners () {
      return {
        ...this.$listeners,
        change: this.uploadImage
      }
    },
    attrs () {
      return {
        ...this.$attrs,
        type: 'file'
      }
    }
  },
  methods: {
    async uploadImage (event) {
      this.toggleLoading()
      const formData = new FormData()

      formData.append('file', event.target.files[0])

      const { data: response } =
        await service.post(this.url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

      this.$emit('fileUrl', response.url)

      this.toggleLoading()
    },
    ...mapActions({
      toggleLoading: 'loading/toggleActive'
    })
  },
  watch: {
    value () {
      this.input = this.value
    }
  }
}
</script>

<style lang="stylus" scoped>
  label
    display block
    position relative
    color #222
    font-size 12px
    text-transform uppercase

    .text-field
      border-width 1px
      border-style solid
      border-color #d4d4d4
      padding 10.5px 55px 10.5px 20px
      border-radius 5px
      transition border-color ease-in-out .3s
      color #222
      margin-top 3px
      font-size 14px
      text-transform none

      &:focus
        border-color #858585
        outline none

      &--block
        display block
        width 100%

    .error
      position absolute
      width 100%
      top calc(100% + 1px)
      text-align left
      font-size 12px
      color #ff1744
      display none
      text-transform none

    &.has-error
      color #ff1744

      .text-field
        border-color #ff1744

      .error
        display block
</style>



// WEBPACK FOOTER //
// VUploadField.vue?0130d7fe